(function () {
  'use strict';

  const form    = document.getElementById('contact-form');
  const notice  = document.getElementById('contact-notice');
  const submit  = document.getElementById('contact-submit');
  if (!form || !notice || !submit) return;

  const btnText    = submit.querySelector('.contact-form__btn-text');
  const btnSpinner = submit.querySelector('.contact-form__btn-spinner');

  const cfg     = window.akordi_contact || {};
  const siteKey = cfg.recaptcha_site_key || '';

  function showNotice(message, type) {
    notice.textContent = message;
    notice.className   = 'contact-notice contact-notice--' + type;
    notice.hidden      = false;
    notice.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function setLoading(on) {
    submit.disabled   = on;
    btnText.hidden    = on;
    btnSpinner.hidden = !on;
  }

  async function getRecaptchaToken() {
    if (cfg.recaptcha_enabled !== '1' || !siteKey) return '';
    return new Promise((resolve) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(siteKey, { action: 'contact' }).then(resolve);
      });
    });
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const name    = form.contact_name.value.trim();
    const email   = form.contact_email.value.trim();
    const message = form.contact_message.value.trim();

    if (!name || !email || !message) {
      showNotice('Пополнете ги задолжителните полиња.', 'error');
      return;
    }

    setLoading(true);
    notice.hidden = true;

    let rcToken = '';
    try {
      rcToken = await getRecaptchaToken();
    } catch {
      // non-fatal — server will allow through if no secret configured
    }

    const body = new URLSearchParams({
      action:              'akordi_contact',
      nonce:               cfg.nonce || '',
      contact_name:        name,
      contact_email:       email,
      contact_subject:     form.contact_subject.value.trim(),
      contact_message:     message,
      'g-recaptcha-response': rcToken,
    });

    try {
      const res  = await fetch(cfg.ajaxurl, {
        method:  'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body:    body.toString(),
      });
      const json = await res.json();

      if (json.success) {
        showNotice(json.data.message, 'success');
        form.reset();
      } else {
        showNotice(json.data?.message || 'Се случи грешка. Обидете се повторно.', 'error');
      }
    } catch {
      showNotice('Мрежна грешка. Проверете ја конекцијата и обидете се повторно.', 'error');
    } finally {
      setLoading(false);
    }
  });
})();
